module.exports = __webpack_public_path__ + "img/cha.818ffd6f.png";